import { render } from "./onlineSignals.vue?vue&type=template&id=b8799982&scoped=true"
import script from "./onlineSignals.vue?vue&type=script&lang=js"
export * from "./onlineSignals.vue?vue&type=script&lang=js"

import "./onlineSignals.vue?vue&type=style&index=0&id=b8799982&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8799982"]])

export default __exports__